import axios from '@axios';

export default {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		fetchRequestProposalDocuments(ctx, queryParams) {
			return new Promise((resolve, reject) => {
				axios
					.get('/request-proposal-documents', { params: queryParams })
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
		updateRequestProposalDocuments(ctx, { payload }) {
			return new Promise((resolve, reject) => {
				axios
					.put('/request-proposal-documents', payload)
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
		fetchRequestProposalWeightings(ctx, queryParams) {
			return new Promise((resolve, reject) => {
				axios
					.get('/request-proposal-weightings', { params: queryParams })
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
		updateRequestProposalWeighting(ctx, { id, payload }) {
			return new Promise((resolve, reject) => {
				axios
					.put(`/request-proposal-weightings/${id}`, payload)
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		}
	}
}